import { MAIN_CONTENT_ID } from '@/components/accessibility/SkipToMain';
import Hero from '@/components/amex/Hero';
import Welcome from '@/components/amex/Welcome';

import { AmexLogo, Background, Form, Grid, TitleWrapper, Wrapper } from './styles';

const Landing = () => {
	return (
		<>
			<Background src="/_n/images/jasper-lake.webp" objectPosition="left" />
			<Grid>
				<Hero />
				<Form id={MAIN_CONTENT_ID}>
					<Wrapper>
						<TitleWrapper>
							<AmexLogo src="/_n/images/b2b/logos/amex.webp" alt="American Express logo" />
						</TitleWrapper>
					</Wrapper>
					<Welcome />
				</Form>
			</Grid>
		</>
	);
};

export default Landing;
